import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import Head from '../../components/partials/Head/Head';
import Banner from '../../components/UI/GeneralBanner/GeneralBanner';
import InfoBlock from '../../components/UI/InfoBlock/InfoBlock';
import Auxiliary from '../../hoc/Auxiliary';
import Benefits from '../../components/Homepage/Benefits/Benefits';
import Steps from '../../components/UI/Steps/Steps';
import CTA from '../../components/UI/CTA/CTA';
import bgImage from '../../assets/images/banners/10_banner-machine-learn.jpg';

class MachineLearning extends Component{
    render(){
        return(
            <Auxiliary>
                <Head {...this.props} id="machineLearning"/>
                <Banner
                    title={this.props.t('machineLearning:1.title')}
                    icon="purple-squares.svg"
                    bgImage = {bgImage}
                />
                <InfoBlock
                    title={this.props.t('machineLearning:2.title')}
                    infos={this.props.i18n.getResource(this.props.i18n.language, 'machineLearning')['2']['services']}
                />
                <Steps 
                    title= {this.props.t('machineLearning:3.title')}  
                    steps={this.props.i18n.getResource(this.props.i18n.language, 'machineLearning')['3']['steps']}
                />
                <Benefits 
                    {...this.props} 
                    mainTitle = {this.props.t('machineLearning:4.title')}
                    boxesContent = {this.props.i18n.getResource(this.props.i18n.language, 'machineLearning')['4']['benefits']}
                    colorTitle = "green"
                    transKey = "machineLearning:4.benefits."
                />
                <CTA 
                    to = {this.props.t('routes:homepage.path')} 
                    btnText = {this.props.t('partials:cta.btnText')} 
                    claim = {this.props.t('machineLearning:cta.claim')}
                />
            </Auxiliary>
        )
    }
}

export default withTranslation()(MachineLearning);